// src/components/filter.
import React, { useEffect, useMemo, useRef, useState } from "react"
import $ from "jquery"
import "../../../assets/css/trackinglog.css"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { post, get } from "../../../helpers/api_helper"
import DataTable, { createTheme } from "react-data-table-component"
import DataTableExtensions from "react-data-table-component-extensions"
import { cryptoOrderData } from "../../../common/data"
import { toast } from "react-hot-toast"
import moment from "moment-timezone"
import { useFormik } from "formik"
import * as Yup from "yup"
import { useDispatch } from "react-redux"
import config from "../../../config"
import "../../../assets/css/detail_btn.css"
import { saveAs } from "file-saver"
import TableContainer from "../../../components/Common/TableContainer"
//Date Picker
import DatePicker from "react-datepicker"
import TreeCheckboxDropdown from '../../../components/TreeCheckboxDropdown/index';
import TreeCheckboxDropdownCNS from '../../../components/TreeCheckboxDropdownCNS/index';
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  TabContent,
  TabPane,
  NavItem,
  CardBody,
  CardHeader,
  FormGroup,
  NavLink,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import classnames from "classnames"
import axios from "axios"
import { amountFormat } from "../../../assets/js/numberFormatter"
import ReactJson from "react-json-view"
import JsonFormatter from "react-json-formatter"
import loader from "../../../assets/images/loader.gif"
import defaultLoader from "../../../assets/images/default_loader.gif"
import { initGA } from "../../../assets/js/gtag"
import trackingStatus from '../../../assets/js/trackingStatus';
import customStyles from "../../../assets/css/customTableStyle"
import customDarkStyles from "../../../assets/css/customTableDarkStyle"
import OrderViewModal from "../../../components/OrderViewModal"
let page = 1;
let filteredData = [];
let totalTracking = 0;
let dataCompleted = false;
let statusCount = null;
let trackingStatus1 = [];
let visibleStatus = "";
let scrolling = false;
function TrackingLogs(props) {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  }

  const trackingStatusRef = useRef()
  const carrierAndServiceRef = useRef()

  const myDivRef = useRef(null)
  const [allData, setAllData] = useState([])
  // const [filteredData, setFilteredData] = useState([])
  const [filteredDataForSearch, setFilteredDataForSearch] = useState([])
  // const [totalTracking, setTotalTracking] = useState(0);
  const [services, setServices] = useState("");
  const [carriers, setCarriers] = useState("");
  const [treeData, setTreeData] = useState([]);
  const [selectedCSValue, setSelectedCSValue] = useState([]);
  const [selectedStatusValue, setSelectedStatusValue] = useState([]);

  const [from, setFrom] = useState("")
  const [to, setTo] = useState("")
  const [status, setStatus] = useState("")
  const [activeTab, setActiveTab] = useState("")
  const [pending, setPending] = useState(true)
  const [loading, setLoading] = useState(false)
  const [trackingCodeHover, setTrackingCodeHover] = useState("")
  const [searched, setSearched] = useState("")
  // const [statusCount, setStatusCount] = useState(null);

  const [clickedJson, setClickedJson] = useState(null)

  function capitalizeWords(str) {
    // split the string into an array of words
    let words = str.split(" ")

    // capitalize the first letter of each word
    for (let i = 0; i < words.length; i++) {
      words[i] = words[i][0].toUpperCase() + words[i].slice(1)
    }

    // join the words back together into a string and return it
    return words.join(" ")
  }

  function breakLine(str) {
    const length = str.length;
    const every = 50;
    const result = [];
    for (let i = 0; i < length; i += every) {
      result.push(str.slice(i, i + every));
    }
    return result.join("\n");
  }

  const [rowId, setRowId] = useState()
  const [viewModal, setViewModal] = useState(false)

  const columns = [
    {
      name: "Tracking Number",
      // selector: "tracking_code",
      width: "300px",
      // sortable: true,
      style: {
        position: "sticky",
        boxShadow: "0 4px 4px #0000001a",
        left: 0,
        zIndex: 1,
        backgroundColor: localStorage.getItem("theme") == "dark"?"#0f0f0f":"white"
      },
      selector: row => (
        <span
          style={{ cursor: "pointer" }}
          onMouseOver={e => setTrackingCodeHover(row.tracking_code)}
          onMouseOut={() => setTrackingCodeHover("")}
          title={row.tracking_code}
        >
          <img
            style={{ marginRight: "5px" }}
            width={20}
            height={20}
            src="data:image/png;base64,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"
          />
          <a
            target={"_blank"}
            rel={"noreferrer"}
            href={`/track/${row.tracking_code}`}
            style={{color:"#FF6600"}}
          >
          {row.tracking_code}{" "}
          </a>
          <span
            style={{
              color: "#e3e3e3",
              cursor: "pointer",
              display:
                trackingCodeHover == row.tracking_code ? "inline" : "none",
            }}
            className={"bx bx-clipboard"}
            title={"Copy Tracking Number"}
            onClick={() => {
              navigator.clipboard.writeText(row.tracking_code)
              toast.success("Copied!")
            }}
          ></span>
        </span>
      ),
    },
    // {
    {
      name: "To Name",
      selector: row => row.to_name,
      // sortable: true,
      width: "210px",
      // cell: row =>
      //   moment(row.aftership_updated_at).format("MMM DD, YYYY hh:mm A"),
    },
    // {
    {
      name: "Service",
      selector: row => row.service_name,
      // sortable: true,
      // width: "210px",
      // cell: row =>
      //   moment(row.aftership_updated_at).format("MMM DD, YYYY hh:mm A"),
    },
    {
      name: "Order #",
      // selector: "order_number",
      sortable: true,
      width: "140px",
      conditionalCellStyles: [
        {
          when: row => row.order_number,
          style: {
            color: "#FF6600", fontWeight: "500", cursor: "pointer"
          }
        }],
      button: true,
      reorder: true,
      selector: row => row.order_number ? <span onClick={() => {
        setRowId(row.order_id)
        setViewModal(true)
      }}>{row.order_number}</span> : "-",
    },
    {
      name: "Status",
      // selector: "status",
      // sortable: true,
      width: "180px",
      selector: row => (
        <span
          style={{
            // background: row.status
            //   ? bgColor.filter(el => el.tag == row.status)[0].color
            //   : "#b9b0b0",
            background: "#e4e5e7",
            padding: "2px 8px 2px 5px",
            borderRadius: "99999px",
            fontSize:"12px",
            color: "#333"
          }}
        >
          <span
            style={{
              width: "15px",
              height: "15px",
              display: "block",
              float: "left",
              marginTop: "2px",
              marginRight: "10px",
              borderRadius: "50%",
              backgroundColor: row.status
                ? colors.filter(el => el.tag == row.status)[0].color
                : "#cccccc",
            }}
          ></span>{" "}
          {row.status ? row.status : "Pending"}
        </span>
      ),
      // cell: row => row.charge_status == "charge:created" ? <span className={"badge badge-warning"}>{capitalizeWords(row.charge_status.replaceAll(":"," "))}</span>:(row.charge_status == "charge:failed"?<span className={"badge badge-danger"}>{capitalizeWords(row.charge_status.replaceAll(":"," "))}</span>:(row.charge_status == "charge:confirmed"?<span className={"badge badge-success"}>{capitalizeWords(row.charge_status.replaceAll(":"," "))}</span>:<span className={"badge badge-light"}>{capitalizeWords(row.charge_status.replaceAll(":"," "))}</span>))
      // cell: row => row.charge_status == "charge.created" ? <span className={"badge badge-danger"}>Pending</span>:<span className={"badge badge-success"}>Charged</span>
    },
    {
      name: "Date",
      // selector: "aftership_updated_at",
      sortable: true,
      width: "210px",
      selector: row =>
        row.aftership_updated_at
          ? moment(row.aftership_updated_at).tz(moment.tz.guess()).format("MMM DD, YYYY hh:mm A")
          : moment(row.updated_at).tz(moment.tz.guess()).format("MMM DD, YYYY hh:mm A"),
    },
    {
      name: "Est. Delivery Date",
      // selector: "json",
      // sortable: true,
      width: "210px",
      selector: row =>
        row.json
          ? JSON.parse(row.json).expected_delivery != null
          ? moment(JSON.parse(row.json).expected_delivery).format(
            "MMM DD, YYYY hh:mm A"
          )
          : "-"
          : "-",
    },
    {
      name: "Latest Event",
      // selector: "json",
      // sortable: true,
      width: "210px",
      selector: row =>
        row.json ? (
          JSON.parse(row.json).checkpoints.length > 0 ? (
            <span
              title={
                breakLine(JSON.parse(row.json).checkpoints[
                JSON.parse(row.json).checkpoints.length - 1
                  ].message)
              }
              className="aa"
            >
              {JSON.parse(row.json).checkpoints[
              JSON.parse(row.json).checkpoints.length - 1
                ].message.length > 20
                ? JSON.parse(row.json).checkpoints[
              JSON.parse(row.json).checkpoints.length - 1
                ].message.substr(0, 20) + "..."
                : JSON.parse(row.json).checkpoints[
                JSON.parse(row.json).checkpoints.length - 1
                  ].message}
              {/*{JSON.parse(row.json).checkpoints[*/}
              {/*JSON.parse(row.json).checkpoints.length - 1*/}
              {/*  ].subtag}*/}
            </span>
          ) : (
            <span
              title={
                breakLine(JSON.parse(row.json).tag)
              }
              className="aa"
            >
            {JSON.parse(row.json).tag}
            </span>
          )
        ) : (
          "-"
        ),
    },
    {
      name: "Origin",
      // selector: "json",
      // sortable: true,
      width: "210px",
      selector: row =>
        row.json
          ? JSON.parse(row.json).origin_city && JSON.parse(row.json).origin_state
          ? <>
          <span style={{marginRight:"5px"}} className={`fi fi-${JSON.parse(row.json).origin_country_iso3=='USA'?'us':JSON.parse(row.json).origin_country_iso3.toString().toLowerCase()}`}></span> {JSON.parse(row.json).origin_city}, {JSON.parse(row.json).origin_state}
          </>
          : "-"
          : "-",
    },
    {
      name: "Destination",
      // selector: "json",
      // sortable: true,
      width: "210px",
      selector: row =>
        row.json
          ? JSON.parse(row.json).destination_city && JSON.parse(row.json).destination_state
          ? <>
            <span style={{marginRight:"5px"}} className={`fi fi-${JSON.parse(row.json).destination_country_iso3?(JSON.parse(row.json).destination_country_iso3=='USA'?'us':JSON.parse(row.json).destination_country_iso3.toString().toLowerCase()):'us'}`}></span> {JSON.parse(row.json).destination_city}, {JSON.parse(row.json).destination_state}
          </>
          : "-"
          : "-",
    },
    {
      name: "Created At",
      // selector: "json",
      // sortable: true,
      width: "180px",
      selector: row =>
        row.json
          ? JSON.parse(row.json).checkpoints.length > 0
          ? moment(
            JSON.parse(row.json).checkpoints[0].checkpoint_time
          ).format("MMM DD, YYYY hh:mm A")
          : moment(JSON.parse(row.json).created_at).tz(moment.tz.guess()).format("MMM DD, YYYY hh:mm A")
          : moment(row.updated_at).tz(moment.tz.guess()).format("MMM DD, YYYY hh:mm A"),
    },
    {
      name: "",
      selector: row => row.order_unique_id,
      omit: true
    },
    {
      name: "",
      selector: row => row.order_number,
      omit: true
    },
    {
      name: "",
      selector: row => row.reference_number,
      omit: true
    },
    {
      name: "",
      selector: row => row.custom_reference_1,
      omit: true
    },
    {
      name: "",
      selector: row => row.custom_reference_2,
      omit: true
    }
    // {
    //   name: "Actions",
    //   selector: "details",
    //   // sortable: true,
    //   style: {
    //     fontWeight: "600",
    //     color: "#ff6600",
    //     cursor: "pointer",
    //   },
    //   width: "120px",
    //   // cell: row => <span style={{fontWeight:"600"}} onClick={() => document.getElementById("").click()}>Details <i style={{fontSize:"8px"}} className={"bx bxs-down-arrow"}></i></span>
    //   // cell: row => row.charge_status == "charge:created" ? <span className={"badge badge-warning"}>{capitalizeWords(row.charge_status.replaceAll(":"," "))}</span>:(row.charge_status == "charge:failed"?<span className={"badge badge-danger"}>{capitalizeWords(row.charge_status.replaceAll(":"," "))}</span>:(row.charge_status == "charge:confirmed"?<span className={"badge badge-success"}>{capitalizeWords(row.charge_status.replaceAll(":"," "))}</span>:<span className={"badge badge-light"}>{capitalizeWords(row.charge_status.replaceAll(":"," "))}</span>))
    //   // cell: row => row.charge_status == "charge.created" ? <span className={"badge badge-danger"}>Pending</span>:<span className={"badge badge-success"}>Charged</span>
    // },
  ]

  const recursiveRetrieve = (page, orderData = []) => {
    let body = {
      id: JSON.parse(localStorage.getItem("authUser")).id,
      page: page,
    }
    post("/user/get-orders-tracking", body, { headers }).then(
      async response => {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let res
            if (orderData.length == 0) {
              res = response.data
            } else {
              res = orderData.concat(response.data)
            }
            setAllData(res)
            //setFilteredData(res)
            setFilteredDataForSearch(res)
            let data = res
            // console.log("table data", { columns, data })
            //setTableData({ columns, data })
            setPending(false)
            let nextPage = +page + +1
            // console.log("next page", nextPage)
            await recursiveRetrieve(nextPage, res)
          } else {
            setAllData(orderData)
            //setFilteredData(orderData)
            setFilteredDataForSearch(orderData)
            let data = orderData
            // console.log("table data", { columns, data })
            //setTableData({ columns, data })
            setPending(false)
            return data
          }
        } else {
          setAllData(orderData)
          //setFilteredData(orderData)
          setFilteredDataForSearch(orderData)
          let data = orderData
          // console.log("table data", { columns, data })
          //setTableData({ columns, data })
          setPending(false)
          return data
        }
      }
    )
  }

  const retrieveTrackingLogs = async () => {
    try {
      setPending(true)
      // console.log("retrieveTrackingLogs")
      let body = {
        id: JSON.parse(localStorage.getItem("authUser")).id,
      }
      // let page = 1;
      // const fetchingOrders = await recursiveRetrieve(page);
      // // console.log("fetchingOrders",fetchingOrders);
      //
      post(`/user/get-orders-tracking`, body, { headers })
        .then(response => {
          // console.log("get-orders-tracking response", response)
          setAllData(response.data)
          //setFilteredData(response.data)
          setFilteredDataForSearch(response.data)
          let data = response.data
          // console.log("table data", { columns, data })
          //setTableData({ columns, data })
          setPending(false)
        })
        .catch(() => {
          setPending(false)
        })
    } catch (e) {
      // console.log(e)
    }
  }

  const getTrackingLogs = async (carriers, services, status, from, to, searched) => {
    try {
      // console.log("scrolling",scrolling);
      document.body.style.pointerEvents = "none";
      // if(!scrolling) {
        scrolling = true;
        let body = {
          user_id: JSON.parse(localStorage.getItem("authUser")).id,
          carriers: carriers,
          services: services,
          status: status,
          from: from,
          to: to,
          searched: searched,
          page: page
        }
        // console.log("getTrackingLogs body",body);
        post("/user/get-orders-tracking-by-offset", body, { headers }).then(
          // post("/user/get-orders-completed-by-carrier", body, { headers }).then(
          (response) => {
            // console.log("get-orders-tracking-by-offset response.data.length", response.data);
            if(response.data.length > 0 && filteredData.length <= totalTracking) {
              let mergeData = filteredData.length > 0?filteredData.concat(response.data):response.data;
              filteredData = mergeData;
              // console.log("all data length", filteredData.length);
              // // console.log("shipping_details", JSON.parse(response.data[0].shipping_details).shipment_id);
              setPending(false)
              setLoading(false);
              dataCompleted = false;
              page  = page + 1;
            }
            else {
              dataCompleted = true;
              setLoading(false);
              setPending(false);
            }

            if(filteredData.length == totalTracking){
              dataCompleted = true;
            }

            document.body.style.pointerEvents = "auto";
            scrolling = false;
          }
        ).catch((e) => {
          // console.log("error in tracking logs",e);
          scrolling = false;
        });
      // }
      // else {
      //   // console.log("scroling siable becuase loading record")
      // }
    } catch (e) {
      // console.log("getTrackingLogs error",e)
      scrolling = false;
    }
  }

  const getTrackingLogsCount = async (carriers, services, status, from, to, searched) => {
    try {
      let body = {
        user_id: JSON.parse(localStorage.getItem("authUser")).id,
        carriers: carriers,
        services: services,
        status: status,
        from: from,
        to: to,
        searched: searched,
      }
      // console.log("body",body);
      post("/user/get-orders-tracking-total-count", body, { headers }).then(
        // post("/user/get-orders-completed-by-carrier", body, { headers }).then(
        (response) => {
          // console.log("get-orders-tracking-total-offset response.data.length", response.data);
          if(response.status == 200) {
            totalTracking = response.data;
          }
        }
      );
    } catch (e) {
      // console.log("getTrackingLogs error",e)
    }
  }

  const getTrackingLogsStatusCount = async () => {
    try {
      let body = {
        user_id: JSON.parse(localStorage.getItem("authUser")).id
      }
      // console.log("body",body);
      post("/user/get-orders-tracking-status-count", body, { headers }).then(
        // post("/user/get-orders-completed-by-carrier", body, { headers }).then(
        (response) => {
          // console.log("get-orders-tracking-total-offset response.data.length", response.data);
          if(response.status == 200) {
            statusCount = response.data;
            for (let i=-0;i<trackingStatus.length;i++) {
              // console.log(trackingStatus[i]);
              // console.log(statusCount);
              if(trackingStatus[i].hasChild != true && trackingStatus[i].hasChild != false) {
                // console.log("trackingStatus[i]",trackingStatus[i],"lnnn",statusCount.allData.filter(el => el.tracking_subtag_code == trackingStatus[i].id).length);
                trackingStatus[i].count = statusCount?statusCount.allData.filter(el => el.tracking_subtag_code == trackingStatus[i].id).length:null;
              }
              else {
                // console.log("trackingStatus[i]",trackingStatus[i],"lnnnxxxxxxxxxxxxx",statusCount[trackingStatus[i].id]);
                trackingStatus[i].count = statusCount?statusCount.allData.filter(el => el.status == trackingStatus[i].id).length:null;
              }
            }
            trackingStatus1 = trackingStatus;
            // console.log("trackingStatus",trackingStatus);
            retrieveCarriersAndServices();

          }
        }
      );
    } catch (e) {
      // console.log("getTrackingLogs error",e)
    }
  }



  const retrieveCarriersAndServices = async () => {
    try {
      let carriersData = [];
      let servicesData = [];
      let finalData = [];
      get("/admin/get-carriers", { headers }).then(response => {
        // console.log("carriers", response)
        // setCarriers(response.data)
        carriersData = response.data;
        get('/admin/get-services', { headers }).then((responseService) => {
          // // console.log("response", response);
          // setServices(responseService.data);
          servicesData = responseService.data;

          for (let i=0;i<carriersData.length;i++) {
            finalData.push({ id: "carrier-"+carriersData[i].name, value: carriersData[i].name, hasChild: true , count: statusCount.allData.filter(el => el.carrier_name == carriersData[i].name).length })
            for (let j=0;j<servicesData.length;j++) {
              if(servicesData[j].carrier_id == carriersData[i].id) {
                finalData.push({ id: "service-"+servicesData[j].id, parent_id: "carrier-"+carriersData[i].name, value: servicesData[j].name, count: statusCount.allData.filter(el => el.service_id == servicesData[j].id).length})
              }
            }
          }

          // console.log("carriersData",carriersData);
          // console.log("servicesData",servicesData);
          // console.log("finalData",finalData);
          setTreeData(finalData);
          setPending(false)
        })
      });

    }
    catch (e) {
      // console.log(e)
    }
  }

  let fields = { dataSource: treeData, value: 'id', text: 'name', parentValue: "pid", hasChildren: 'hasChild' };
  let treeSettings = { autoCheck: true };

  let fields1 = { dataSource: trackingStatus1, value: 'id', text: 'name', parentValue: "pid", hasChildren: 'hasChild' };
  let treeSettings1 = { autoCheck: true };

  function getDivByInnerText(innerText) {
    const divElements = document.querySelectorAll('div');

    for (const div of divElements) {
      if (div.innerText.includes(innerText)) {
        return div;
      }
    }

    return null; // If no matching div is found
  }

  useEffect(() => {
    // const innerText = 'This application was built using a trial version of Syncfusion Essential Studio. To remove the license validation message permanently, a valid license key must be included';
    // const divElement = getDivByInnerText(innerText);
    // divElement.style.display = "none";
    // const innerText1 = 'Claim your FREE account and get a key in less than a minute';
    // const divElement1 = getDivByInnerText(innerText1);
    // if(divElement1) {
    //   divElement1.parentNode.parentNode.style.display = "none";
    // }


    // // console.log("divElement",divElement);
    // if(config.site.MODE == "production") {
    //   initGA();
    // }
    page = 1;
    filteredData = [];
    dataCompleted = false;
    setPending(true);
    // retrieveTrackingLogs()
    getTrackingLogsStatusCount();
    getTrackingLogsCount(carriers, services, status, from, to, searched).then(() => {
      getTrackingLogs(carriers, services, status, from, to, searched);
    });


  }, [])

  // useEffect(() => {
  //   window.addEventListener('scroll', handleScroll);
  //   return () => window.removeEventListener('scroll', handleScroll);
  // }, [filteredData]);


  // async function handleScroll() {
  //   // console.log("scrolling")
  //   // console.log("parseInt(window.innerHeight + document.documentElement.scrollTop)",parseInt(window.innerHeight + document.documentElement.scrollTop))
  //   // console.log("parseInt(document.documentElement.scrollHeight)",parseInt(document.documentElement.scrollHeight))
  //   // if ((parseInt(window.innerHeight + document.documentElement.scrollTop)) == parseInt(document.documentElement.scrollHeight)) {// this is causing loading issue data was not loading
  //   if ((parseInt(document.documentElement.scrollHeight) - parseInt(window.innerHeight + document.documentElement.scrollTop)) <= 5) {
  //     // console.log("scrolling bottom",dataCompleted);
  //     if(!dataCompleted) {
  //       setLoading(true);
  //     }
  //     await getTrackingLogsCount(carriers, services, status, from, to, searched);
  //     await getTrackingLogs(carriers, services, status, from, to, searched);
  //   }
  // }

  const handleLoadMore = async () => {
    if(!dataCompleted) {
      setLoading(true);
    }
    await getTrackingLogsCount(carriers, services, status, from, to, searched);
    await getTrackingLogs(carriers, services, status, from, to, searched);
  }


  const ExpandedComponent = props => {
    const jsonStyle = {
      propertyStyle: { fontWeight: "600" },
      stringStyle: {},
      numberStyle: {},
    }
    // console.log("props", props)
    return (
      <div
        className={"col-md-12"}
        key={props.data.tracking_code}
        style={{ backgroundColor: "#fafafa" }}
      >
        <h3 style={{ padding: "20px" }}>{props.data.tracking_code}</h3>
        <div className={"col-md-12 p-3"} style={{ marginTop: "-20px" }}>
          <div className={"row"}>
            <div className={"col-md-8"}>
              <div className={"bg-white p-2 rounded shadow"}>
                <JsonFormatter
                  json={props.data.json}
                  tabWith={5}
                  jsonStyle={jsonStyle}
                />
              </div>
            </div>
            <div className={"col-md-4 mt-3"}>
              <h4>Tracking URL</h4>
              <a
                target={"_blank"}
                rel={"noreferrer"}
                href={`/track/${props.data.tracking_code}`}
              >
                <p>
                  {config.site.URL}/track/{props.data.tracking_code}
                </p>
              </a>
              <br />
              <h4>Tracking Details</h4>
              <hr />
              {JSON.parse(props.data.json).checkpoints.length > 0 ? (
                JSON.parse(props.data.json).checkpoints.map((part, id) => {
                  return (
                    <div key={id}>
                      <h5>
                        {moment(part.checkpoint_time).format(
                          "MMM DD, YYYY hh:mm A"
                        )}
                      </h5>
                      <p>{part.message}</p>
                    </div>
                  )
                })
              ) : (
                <>
                  <h5>
                    {moment(JSON.parse(props.data.json).last_updated_at).format(
                      "MMM DD, YYYY hh:mm A"
                    )}
                  </h5>
                  <p>{JSON.parse(props.data.json).tag}</p>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  const handleFrom = async e => {
    page = 1;
    filteredData = [];
    dataCompleted = false;
    setPending(true);
    let { value } = e.target
    setFrom(value)
    await getTrackingLogsCount(carriers, services, status, value, to, searched);
    await getTrackingLogs(carriers, services, status, value, to, searched);
  }

  const handleTo = async e => {
    page = 1;
    filteredData = [];
    dataCompleted = false;
    setPending(true);
    let { value } = e.target
    setTo(value)
    await getTrackingLogsCount(carriers, services, status, from, value, searched);
    await getTrackingLogs(carriers, services, status, from, value, searched);
  }

  const handleSearch = async (e) => {
    page = 1;
    filteredData = [];
    dataCompleted = false;
    setPending(true);
    let { value } = e.target
    setSearched(value)
    await getTrackingLogsCount(carriers, services, status, from, to, value);
    await getTrackingLogs(carriers, services, status, from, to, value);
  }

  const handleStatus = async e => {
    page = 1;
    filteredData = [];
    dataCompleted = false;
    setPending(true);
    let { value } = e.target
    setActiveTab(value)
    setStatus(value)
    await getTrackingLogsCount(carriers, services, value, from, to, searched);
    await getTrackingLogs(carriers, services, value, from, to, searched);
  }

  const handleSelectStatus = async (e) => {
    // console.log("handleSelectStatus",e)
    page = 1;
    filteredData = [];
    dataCompleted = false;
    setPending(true);
    // console.log("e",e);
    setSelectedStatusValue(e.to_display);
    const selectedItems = e.to_filter;
    if(selectedItems.length > 0) {
      // console.log("selectedItems status.toString()",selectedItems.toString());
      let stts = [];
      for (let i=0;i<selectedItems.length; i++) {
        stts.push("'" + selectedItems[i].id + "'");
      }
      setStatus(stts.toString());
      await getTrackingLogsCount(carriers, services , stts.toString(), from, to, searched);
      await getTrackingLogs(carriers, services, stts.toString(), from, to, searched);
    }
    else {
      setStatus("");
      await getTrackingLogsCount(carriers, services , "", from, to, searched);
      await getTrackingLogs(carriers, services, "", from, to, searched);
    }
  };

  const handleSelect = async (e) => {
    page = 1;
    filteredData = [];
    dataCompleted = false;
    setPending(true);
    // console.log("e",e.to_filter);
    setSelectedCSValue(e.to_display);
    const selectedItems = e.to_filter;
    let carr = [];
    let ser = [];
    // if(selectedItems.length > 0) {
      for (let i=0;i<selectedItems.length; i++) {
        // console.log("selectedItemsselectedItemsselectedItems",selectedItems[i]);
        if(selectedItems[i].id.split("-")[0] == "carrier") {
          carr.push("'" + selectedItems[i].id.split("-")[1] + "'");
        }

        if(selectedItems[i].id.split("-")[0] == "service") {
          ser.push(selectedItems[i].id.split("-")[1]);
        }
      }

      // console.log('Selected Items:', selectedItems);
      // console.log('Selected carr:', carr);
      // console.log('Selected ser:', ser);

      setCarriers(carr.toString());
      setServices(ser.toString());
      await getTrackingLogsCount(carr.toString(), ser.toString() , status, from, to, searched);
      await getTrackingLogs(carr.toString(), ser.toString(), status, from, to, searched);
    // }
    // else {
    //   setCarriers("");
    //   setServices("");
    //   await getTrackingLogsCount("", "" , status, from, to, searched);
    //   await getTrackingLogs("", "", status, from, to, searched);
    // }
  };



  const handleToggle = async e => {
    page = 1;
    filteredData = [];
    dataCompleted = false;
    setPending(true);
    let value = e.target.name
    setActiveTab(value)
    if(value != "") {
      setStatus("'"+value+"'")
      await getTrackingLogsCount(carriers, services, "'"+value+"'", from, to, searched);
      await getTrackingLogs(carriers, services , "'"+value+"'", from, to, searched);
    }
    else {
      setStatus('')
      await getTrackingLogsCount(carriers, services, '', from, to, searched);
      await getTrackingLogs(carriers, services , '', from, to, searched);
    }

    // await FilterCarrierTracking(from, to, value, "all")
  }
  const handleRowClick = row => {
    // Handle row click event here
    let data = row
    // console.log("data", data)

    if (data && data.json) {
      document.body.style.overflow = "hidden"
      setClickedJson(data)
    } else {
      toast.error("Tracking do not exist")
    }
  }

  const formatAsNumber = (data, columnName) => {
    return data.map((item) => ({
      ...item,
      ['Tracking Code']: Number(item['Tracking Code']),
    }));
  };

  const handleExport = () => {
    // console.log("filtered data", filteredData)
    if (filteredData.length > 0) {
      let header =
        "Order ID,To Name,Tracking Code,Tracking Created At,Tracking Updated At,Tracking Status,Tracking Slug,Carrier,Service,Est. Delivery Date,Current Detail Message,Current Detail Status,Current Detail Date,Destination Street1,Destination Street2,Destination State,Destination City,Destination Zip,Destination Country,Order Number,Reference Number,Custom Reference 1,Custom Reference 2, Order Date, Weight, Tracking Url\n"
      let data = ""
      for (let i = 0; i < filteredData.length; i++) {
        let json = JSON.parse(filteredData[i].json);
        if(filteredData[i].to_street1 && filteredData[i].to_state && filteredData[i].to_city && filteredData[i].to_zip && filteredData[i].to_country) {
          // // console.log("filteredData[i].to_street1",filteredData[i]);
          let order_id = filteredData[i].order_unique_id;
          let order_number = filteredData[i].order_number?filteredData[i].order_number.toString().replaceAll("\n"," ").replaceAll(",", ' '):"-";
          let reference_number = filteredData[i].reference_number?filteredData[i].reference_number.toString().replaceAll("\n"," ").replace(/[^a-zA-Z0-9 ]/g, ''):"-";
          let custom_reference_1 = filteredData[i].custom_reference_1?filteredData[i].custom_reference_1.toString().replaceAll("\n"," ").replace(/[^a-zA-Z0-9 ]/g, ''):"-";
          let custom_reference_2 = filteredData[i].custom_reference_2?filteredData[i].custom_reference_2.toString().replaceAll("\n"," ").replace(/[^a-zA-Z0-9 ]/g, ''):"-";
          let to_name = filteredData[i].to_name.toString().replaceAll("\n"," ").replace(/[^a-zA-Z0-9 ]/g, '');
          let destination_street1 = filteredData[i].to_street1.toString().replaceAll("\n"," ").replace(/[^a-zA-Z0-9 ]/g, '');
          let destination_street2 = filteredData[i].to_street2?filteredData[i].to_street2.toString().replaceAll("\n"," ").replace(/[^a-zA-Z0-9 ]/g, ''):"-";
          let destination_state = filteredData[i].to_state;
          let destination_city = filteredData[i].to_city;
          let destination_zip = filteredData[i].to_zip;
          let destination_country = filteredData[i].to_country;
          let tracking_code = filteredData[i].tracking_code;
          let tracking_created_at = filteredData[i].created_at;
          let tracking_updated_at = filteredData[i].aftership_updated_at?filteredData[i].aftership_updated_at:"-";
          let tracking_status = filteredData[i].status.toString().replaceAll("\n"," ").replace(/[^a-zA-Z0-9 ]/g, '');
          let tracking_slug = json?json.slug:"-";
          let carrier = filteredData[i].carrier_name;
          let service = filteredData[i].service_name;
          let est_delivery_date = json?json.expected_delivery:"-";
          let current_detail_message = json? json.checkpoints.length > 0
            ? json.checkpoints[json.checkpoints.length - 1].message.toString().replaceAll("\n"," ").replace(/[^a-zA-Z0-9 ]/g, '')
            : "Pending":"-";
          let current_detail_status =
            json?json.checkpoints.length > 0
              ? json.checkpoints[json.checkpoints.length - 1].tag.toString().replaceAll("\n"," ").replace(/[^a-zA-Z0-9 ]/g, '')
              : "Pending":"-";
          let current_detail_date =
            json?json.checkpoints.length > 0
              ? json.checkpoints[json.checkpoints.length - 1].created_at
              : filteredData[i].aftership_updated_at:"-";
          let created_at = filteredData[i].created_at;
          let weight = filteredData[i].weight;
          let public_url =
            config.site.URL + "/track/" + filteredData[i].tracking_code;

          data += `${order_id},${to_name},'${tracking_code}',${tracking_created_at},${tracking_updated_at},${tracking_status},${tracking_slug},${carrier},${service},${est_delivery_date},${current_detail_message},${current_detail_status},${current_detail_date},${destination_street1},${destination_street2},${destination_state},${destination_city},${destination_zip},${destination_country},${order_number},${reference_number},${custom_reference_1},${custom_reference_2},${created_at},${weight},${public_url}\n`
        }

      }

      // console.log("data is", data)

      let final_data = header + data
      const blob = new Blob([final_data], { type: "text/csv;charset=utf-8" })
      saveAs(
        blob,
        "tracking-logs-" + moment(new Date()).format("DD-MMM-YYYY") + ".csv"
      )
    }
  }

  const colors = [
    {
      tag: "InfoReceived",
      subtag: "InfoReceived_001",
      color: "#2e4871",
    },
    {
      tag: "InTransit",
      subtag: "InTransit_001",
      color: "#4598d6",
    },
    {
      tag: "OutForDelivery",
      subtag: "OutForDelivery_001",
      color: "#e77f12",
    },
    {
      tag: "AttemptFail",
      subtag: "AttemptFail_001",
      color: "#9b59b6",
    },
    {
      tag: "Delivered",
      subtag: "Delivered_001",
      color: "#4baa67",
    },
    {
      tag: "AvailableForPickup",
      subtag: "AvailableForPickup_001",
      color: "#ef7414",
    },
    {
      tag: "Exception",
      subtag: "Exception_001",
      color: "#b74432",
    },
    {
      tag: "Expired",
      subtag: "Expired_001",
      color: "#616e7d",
    },
    {
      tag: "Pending",
      subtag: "Pending_001",
      color: "#cccccc",
    },
  ]
  const bgColor = [
    {
      tag: "InfoReceived",
      color: "rgb(141 161 193)",
    },
    {
      tag: "InTransit",
      color: "#97b3c9",
    },
    {
      tag: "OutForDelivery",
      color: "#efd3b6",
    },
    {
      tag: "AttemptFail",
      color: "#d9b6e7",
    },
    {
      tag: "Delivered",
      color: "lch(85 27.62 151.79)",
    },
    {
      tag: "AvailableForPickup",
      color: "#f7c8a3",
    },
    {
      tag: "Exception",
      color: "#cd8a7f",
    },
    {
      tag: "Expired",
      color: "#b0cae7",
    },
    {
      tag: "Pending",
      color: "#b9b0b0",
    },
  ]
  const images = [
    {
      tag: "InfoReceived",
      enum: "2643e8a28995471cfb70e4ce1789c995",
    },
    {
      tag: "InTransit",
      enum: "81c9368125eb43a7e2ffd7fa10668fc1",
    },
    {
      tag: "OutForDelivery",
      enum: "f7139b1eeb164be3fd38d4181dab839d",
    },
    {
      tag: "AttemptFail",
      enum: "ad9982a948144acaee0fbd211fe7eb5f",
    },
    {
      tag: "Delivered",
      enum: "9ea84d540ce143b7f0860b57126a6aa4",
    },
    {
      tag: "AvailableForPickup",
      enum: "43013fad6d88413be9d46bdf14d8e9ad",
    },
    {
      tag: "Exception",
      enum: "a36a77ee7f214270e5699d461d05b070",
    },
    {
      tag: "Expired",
      enum: "1c62e75b04494c45ffd626f814c0a16c",
    },
    {
      tag: "Pending",
      enum: "0cc21407bd0a459ef0ba7e201505872d",
    },
  ]

  function removeDuplicateObjects(arr) {
    const uniqueArr = [];
    const ids = [];


    for (const obj of arr) {
      let found = uniqueArr.some(el => el.order_id == obj.order_id);
      if (!found) {
        uniqueArr.push(obj);
        // ids.push(parseInt(obj.order_id));
      }
    }

    // console.log("uniqueArr",uniqueArr);
    return uniqueArr;
  }

  const treeRef = useRef(null);


  createTheme('solarized', {
    text: {
      primary: '#fffff',
      secondary: '#fffff',
    },
    background: {
      default: '#0f0f0f',
    },
    context: {
      background: '#cb4b16',
      text: '#0f0f0f',
    },
    divider: {
      default: '#282828',
    },
    action: {
      button: 'rgba(0,0,0,.54)',
      hover: 'rgba(0,0,0,.08)',
      disabled: 'rgba(0,0,0,.12)',
    },
  }, 'dark');


  //meta title
  document.title = `Orders Tracking | ${config.APP_DETAILS.APP_NAME}`


  function convertToK(num) {
    if (num >= 1000) {
      var suffixes = ["", "k", "m", "b", "t"]
      var suffixNum = Math.floor(("" + num).length / 3)
      var shortValue = parseFloat(
        (suffixNum !== 0 ? num / Math.pow(1000, suffixNum) : num).toPrecision(2)
      )
      if (shortValue % 1 !== 0) {
        shortValue = shortValue.toFixed(1)
      }
      num = shortValue + suffixes[suffixNum]
    }
    return num
  }

  function getUniqueListBy(arr, key) {
    return [...new Map(arr.map(item => [item[key], item])).values()]
  }

  return (
    <div className="page-content">
      <div
        className={
          "tracking-info " +
          (clickedJson ? "tracking-active" : "tracking-inactive")
        }
        style={{backgroundColor:localStorage.getItem("theme") == "dark"?"#0f0f0f":"white"}}
      >
        <div className={"head"}>
          <span
            className={"close-btn"}
            onClick={() => {
              document.body.style.overflow = "visible"
              setClickedJson(null)
            }}
          >
            ⨉
          </span>
          <h4
            onClick={() => {}}
            style={{ borderBottom: "1px dashed gray", width: "fit-content" }}
          >
            {clickedJson ? JSON.parse(clickedJson.json).tracking_number : "-"}{" "}
            <span
              style={{ color: "#e3e3e3", cursor: "pointer" }}
              className={"bx bx-clipboard"}
              title={"Copy Tracking Number"}
              onClick={() => {
                navigator.clipboard.writeText(
                  clickedJson
                    ? JSON.parse(clickedJson.json).tracking_number
                    : "-"
                )
                toast.success("Copied!")
              }}
            ></span>
          </h4>
          <a
            target={"_blank"}
            rel={"noreferrer"}
            href={
              clickedJson
                ? `/track/${JSON.parse(clickedJson.json).tracking_number}`
                : "#"
            }
          >
            <p>View tracking page</p>
          </a>
        </div>
        <div className={"body"}>
          <h5>
            {clickedJson
              ? JSON.parse(clickedJson.json).checkpoints.length > 0
                ? JSON.parse(clickedJson.json).checkpoints.reverse()[0]
                  .subtag_message +
                " on " +
                moment(
                  JSON.parse(clickedJson.json).checkpoints.reverse()[0]
                    .checkpoint_time
                ).format("MMM DD, YYYY")
                : JSON.parse(clickedJson.json).tag +
                " on " +
                moment(JSON.parse(clickedJson.json).last_updated_at).format(
                  "MMM DD, YYYY"
                )
              : ""}
          </h5>
          <hr />
          {clickedJson ? (
            JSON.parse(clickedJson.json).checkpoints.length > 0 ? (
              JSON.parse(clickedJson.json)
                .checkpoints.reverse()
                .map((part, id) => {
                  return (
                    <div key={id} style={{ display: "flex", width: "100%" }}>
                      <div
                        style={{
                          width: "10%",
                          position: "relative",
                          justifyContent: "center",
                          alignContent: "center",
                          display: "flex",
                        }}
                      >
                        {JSON.parse(clickedJson.json).checkpoints.length - 1 !=
                        id ? (
                          <span className={"dashline"}></span>
                        ) : (
                          ""
                        )}
                        <img
                          style={{ zIndex: "9999", position: "absolute" }}
                          width={"20px"}
                          src={`https://assets.am-static.com/api_docs_center/aftership/testing/docs_api.aftership.com/enum/${
                            images.filter(el => el.tag == part.tag)[0].enum
                          }`}
                        />
                      </div>
                      <div style={{ width: "90%" }}>
                        <h6>{part.subtag_message}</h6>
                        <p className={"tracking-log-location"}>
                          {part.location
                            ? part.location +
                            " • " +
                            part.slug.toString().toUpperCase()
                            : ""}
                        </p>
                        <p className={"tracking-log-dates"}>
                          {moment(part.checkpoint_time).format(
                            "MMM DD, YYYY hh:mm A"
                          )}
                        </p>
                      </div>
                    </div>
                  )
                })
            ) : (
              <div style={{ display: "flex", width: "100%" }}>
                <div
                  style={{
                    width: "10%",
                    position: "relative",
                    justifyContent: "center",
                    alignContent: "center",
                    display: "flex",
                  }}
                >
                  <img
                    style={{ zIndex: "9999", position: "absolute" }}
                    width={"20px"}
                    src={`https://assets.am-static.com/api_docs_center/aftership/testing/docs_api.aftership.com/enum/${
                      images.filter(
                        el => el.tag == JSON.parse(clickedJson.json).tag
                      )[0].enum
                    }`}
                  />
                </div>
                <div style={{ width: "90%" }}>
                  <h6>{JSON.parse(clickedJson.json).tag}</h6>
                  <p className={"tracking-log-location"}></p>
                  <p className={"tracking-log-dates"}>
                    {moment(
                      JSON.parse(clickedJson.json).last_updated_at
                    ).format("MMM DD, YYYY hh:mm A")}
                  </p>
                </div>
              </div>
            )
          ) : (
            "-"
          )}
          <hr />
          <h5>Shipment details</h5>
          {clickedJson ? (
            <>
              <table className={"table"}>
                <tr>
                  <th>Order ID</th>
                  <td style={{ textAlign: "right" }}>
                    {clickedJson.order_unique_id}
                  </td>
                </tr>
                <tr>
                  <th>Ship To Name</th>
                  <td style={{ textAlign: "right" }}>
                    {clickedJson.to_name}
                  </td>
                </tr>
                <tr>
                  <th>Tracking Number</th>
                  <td style={{ textAlign: "right" }}>
                    {clickedJson.tracking_code}
                  </td>
                </tr>
                <tr>
                  <th>Slug</th>
                  <td style={{ textAlign: "right" }}>
                    {JSON.parse(clickedJson.json).slug}
                  </td>
                </tr>
                <tr>
                  <th>Service</th>
                  <td style={{ textAlign: "right" }}>
                    {clickedJson.service_name}
                  </td>
                </tr>
                <tr>
                  <th>Source / created at</th>
                  <td style={{ textAlign: "right" }}>
                    {JSON.parse(clickedJson.json)
                      .source.toString()
                      .toUpperCase() + " / "}{" "}
                    {JSON.parse(clickedJson.json).checkpoints.length > 0
                      ? moment(
                        JSON.parse(clickedJson.json).checkpoints[0]
                          .checkpoint_time
                      ).format("MMM DD, YYYY")
                      : moment(JSON.parse(clickedJson.json).created_at).format(
                        "MMM DD, YYYY"
                      )}
                  </td>
                </tr>
              </table>
              <hr />
              <table className={"table"}>
                <tr>
                  <th>Shipping Address</th>
                  <td style={{ textAlign: "right" }}>
                    {clickedJson.to_street1 +
                    ", " +
                    clickedJson.to_state +
                    ", " +
                    clickedJson.to_city +
                    ", " +
                    clickedJson.to_zip +
                    ", " +
                    clickedJson.to_country}
                  </td>
                </tr>
              </table>
              {JSON.parse(clickedJson.json).latest_estimated_delivery ? (
                <hr />
              ) : (
                ""
              )}
              <table className={"table"}>
                {JSON.parse(clickedJson.json).latest_estimated_delivery ? (
                  <tr>
                    <th>Original promised EDD</th>
                    <td style={{ textAlign: "right" }}>
                      {moment(
                        JSON.parse(clickedJson.json).latest_estimated_delivery
                          .datetime
                      ).format("MMM DD, YYYY")}
                    </td>
                  </tr>
                ) : (
                  ""
                )}
                {JSON.parse(clickedJson.json).latest_estimated_delivery ? (
                  <tr>
                    <th>Promised By</th>
                    <td style={{ textAlign: "right" }}>
                      {
                        JSON.parse(clickedJson.json).latest_estimated_delivery
                          .source
                      }
                    </td>
                  </tr>
                ) : (
                  ""
                )}
              </table>
              <hr />
              <table className={"table"}>
                {JSON.parse(clickedJson.json).shipment_delivery_date ? (
                  <tr>
                    <th>Delivery Date</th>
                    <td style={{ textAlign: "right" }}>
                      {moment(
                        JSON.parse(clickedJson.json).shipment_delivery_date
                      ).format("MMM DD, YYYY")}
                    </td>
                  </tr>
                ) : (
                  ""
                )}
                {JSON.parse(clickedJson.json).shipment_pickup_date ? (
                  <tr>
                    <th>Pickup Date</th>
                    <td style={{ textAlign: "right" }}>
                      {moment(
                        JSON.parse(clickedJson.json).shipment_pickup_date
                      ).format("MMM DD, YYYY")}
                    </td>
                  </tr>
                ) : (
                  ""
                )}
              </table>
            </>
          ) : (
            ""
          )}
        </div>
      </div>
      <div
        className={
          "main-tracking-info " +
          (clickedJson ? "main-active" : "main-inactive")
        }
        onClick={() => {
          document.body.style.overflow = "visible"
          setClickedJson(null)
        }}
      ></div>

      <div className="container-fluid">
        <Breadcrumbs title={config.APP_DETAILS.APP_NAME} breadcrumbItem="Orders Tracking" />
        <Card>
          <CardHeader
            style={{
              paddingTop: "0px",
              paddingBottom: "0px",
              paddingLeft: "14px",
              backgroundColor: localStorage.getItem("theme") == "dark"?"#0f0f0f":"white"
            }}
          >
            <Row>
              <ul
                className="nav nav-tabs nav-tabs-custom"
                role="tablist"
                style={{ justifyContent: "space-evenly", width: "100%" }}
              >
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "",
                    })}
                    // title="1"
                    name=""
                    onClick={handleToggle}
                  >
                    All ({statusCount? convertToK(statusCount.all) : "-"})
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "Exception_001",
                    })}
                    // title="8"
                    name="Exception_001"
                    onClick={handleToggle}
                  >
                    Exception (
                    {statusCount? convertToK(statusCount.Exception) : "-"}
                    )
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "AttemptFail_001",
                    })}
                    // title="5"
                    name="AttemptFail_001"
                    onClick={handleToggle}
                  >
                    Failed Attempt (
                    {statusCount? convertToK(statusCount.AttemptFail) : "-"}
                    )
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "Expired_001",
                    })}
                    // title="9"
                    onClick={handleToggle}
                    name="Expired_001"
                  >
                    Expired (
                    {statusCount? convertToK(statusCount.Expired) : "-"}
                    )
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "OutForDelivery_001",
                    })}
                    // title="4"
                    name="OutForDelivery_001"
                    onClick={handleToggle}
                  >
                    Out for Delivery (
                    {statusCount? convertToK(statusCount.OutForDelivery) : "-"}
                    )
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "Delivered_001",
                    })}
                    // title="6"
                    onClick={handleToggle}
                    name="Delivered_001"
                  >
                    Delivered (
                    {statusCount? convertToK(statusCount.Delivered) : "-"}
                    )
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "Pending_001",
                    })}
                    // title="10"
                    onClick={handleToggle}
                    name="Pending_001"
                    // onClick={() => {
                    //   toggleTab("1")
                    // }}
                  >
                    Pending (
                    {statusCount? convertToK(statusCount.Pending) : "-"}
                    )
                  </NavLink>
                </NavItem>
              </ul>
            </Row>
          </CardHeader>
          <CardBody>
            <Row>
              <div className={"col-xl-3 col-lg-3 col-md-3 p-1"}>
                <div className="mb-3">
                  <Label className="form-label">Filter</Label>
                  <input
                    type={"text"}
                    className={"form-control"}
                    placeholder={"Filter Tracking..."}
                    onChange={handleSearch}
                    disabled={pending == true && loading == true}
                  />
                </div>
              </div>
              <div className={"col-xl-2 col-lg-3 col-md-3 p-1"}>
                <div className="mb-3">
                  <Label className="form-label">Status</Label>
                  {trackingStatus1.length>0?<TreeCheckboxDropdown ref={trackingStatusRef} data={trackingStatus1} placeholder={"Status"} change={handleSelectStatus}/>:<div style={{width:"100%",height:"37px",border:"1px solid #ced4da",borderRadius:"5px",paddingLeft:"15px",paddingRight:"5px",lineHeight:"37px"}}>Loading...</div>}
                </div>
              </div>
              <div className={"col-xl-2 col-lg-3 col-md-3 p-1"}>
                <div className="mb-3">
                  <Label className="form-label">Carrier/Service</Label>
                  {treeData.length>0?<TreeCheckboxDropdownCNS ref={carrierAndServiceRef} data={treeData} placeholder={"Carriers / Services"} change={handleSelect}/>:<div style={{width:"100%",height:"37px",border:"1px solid #ced4da",borderRadius:"5px",paddingLeft:"15px",paddingRight:"5px",lineHeight:"37px"}}>Loading...</div>}
                </div>
              </div>
              <div className={"col-xl-2 col-lg-3 col-md-3 p-1"}>
                <div className="mb-3">
                  <Label className="form-label">From</Label>
                  <Input
                    name="from"
                    className="form-control"
                    type="date"
                    max={to}
                    value={from}
                    onChange={handleFrom}
                  />
                </div>
              </div>
              <div className={"col-xl-2 col-lg-3 col-md-3 p-1"}>
                <div className="mb-3">
                  <Label className="form-label">To</Label>
                  <Input
                    name="to"
                    className="form-control"
                    type="date"
                    disabled={from == "" ? true : false}
                    title={from == "" ? "Please select from date" : ""}
                    min={from}
                    value={to}
                    onChange={handleTo}
                  />
                </div>
              </div>
              <div className={"col-xl-1 col-lg-2 col-md-1 p-1"}>
                <button
                  className={"btn btn-light"}
                  style={{
                    float: "right",
                    // marginRight: "10px",
                    marginTop: "28px",
                    paddingLeft: "6px",
                    paddingRight: "6px",
                  }}
                  title={"Export"}
                  onClick={handleExport}
                >
                  Export
                  <i style={{marginLeft:"5px"}} className={"bx bx-export"}></i>
                </button>
              </div>
            </Row>
            <Row>
              <div className={"col-md-12"}>

                {selectedStatusValue.length>0?<div style={{width:"fit-content", height:"auto",backgroundColor:"#efefef",padding:"5px",borderRadius:"5px",fontSize:"11px"}}>
                  Status in {
                    selectedStatusValue.map((el, id) => {
                      let index = trackingStatus.findIndex((e) => e.id == el.id);
                      let parentIndex = trackingStatus.findIndex((e) => e.id == el.parent_id);
                      let parentLength = trackingStatus.filter(e => e.parent_id == el.parent_id).length;
                      let totalParentChildSelected = selectedStatusValue.filter(e => e.parent_id == el.parent_id).length;
                      // // console.log("parentLength",parentLength ,"==", totalParentChildSelected)
                      let value = id==(selectedStatusValue.length-1) ? el.value : el.value + ", ";
                      // // console.log("returning value",value);
                      return value;
                    })}
                   <span style={{marginLeft:"10px",fontWeight:"500",cursor:"pointer"}} onClick={() => {
                     setPending(true);
                     trackingStatusRef.current.cancelAll()
                   }}>✕</span>
                </div>:""}
              </div>
            </Row>
            <Row>
              <div className={"col-md-12 mt-1"}>
                {/*{*/}
                {/*  selectedCSValue.map((el, id) => {*/}
                {/*    let index = treeData.findIndex((e) => e.id == el);*/}
                {/*    return <span key={id} className={"badge badge-light p-2"} style={{margin:"3px"}}>{treeData[index].value}</span>;*/}
                {/*  })}*/}

                {selectedCSValue.length>0?<div style={{width:"fit-content", height:"auto",backgroundColor:"#efefef",padding:"5px",borderRadius:"5px",fontSize:"11px"}}>
                  Carrier in {
                    selectedCSValue.map((el, id) => {
                      let index = treeData.findIndex((e) => e.id == el.id);
                      let parentIndex = treeData.findIndex((e) => e.id == el.parent_id);
                      let parentLength = treeData.filter(e => e.parent_id == el.parent_id).length;
                      let totalParentChildSelected = selectedCSValue.filter(e => e.parent_id == el.parent_id).length;
                      // // console.log("parentLength",parentLength ,"==", totalParentChildSelected)
                      let value = id==(selectedCSValue.length-1) ? el.value : el.value + ", ";
                      // // console.log("returning value",value);
                      return value;
                    })}
                  <span style={{marginLeft:"10px",fontWeight:"500",cursor:"pointer"}} onClick={() => {
                    setPending(true);
                    carrierAndServiceRef.current.cancelAll()
                  }}>✕</span>
                </div>:""}
              </div>
            </Row>
            {/*<DataTableExtensions*/}
            {/*  {...tableData}*/}
            {/*  filter={false}*/}
            {/*  filterPlaceholder={`Filter Orders Tracking...`}*/}
            {/*>*/}
            <DataTable
              columns={columns}
              data={filteredData}
              ref={myDivRef}
              filter={false}
              className={"tracking-table sticky-hscroll"}
              // pagination={100}
              // paginationPerPage={100}
              // paginationRowsPerPageOptions={[100, 200, 500]}
              expandOnRowClicked={true}
              subHeaderAlign="left"
              // expandableRows={true}
              expandableIcon={false}
              expandableRowsHideExpander={true}
              responsive={true}
              highlightOnHover={true}
              progressPending={pending}
              theme={localStorage.getItem("theme")=="dark"?"solarized":""} customStyles={localStorage.getItem("theme")=="dark"?customDarkStyles:customStyles}
              progressComponent={
                <h4 className={"mt-5 mb-5 text-center"}>
                  Loading data, this may take a few moments...
                </h4>
              }
              onRowClicked={handleRowClick}
              // expandableRowsComponent={ExpandedComponent}
            />
            {!dataCompleted && !pending && !loading && parseFloat(filteredData.length) != parseFloat(totalTracking)?<div className={"col-md-12 text-center mt-2"}><button onClick={handleLoadMore} className={"btn btn-dark"}>Load More</button></div>:""}
            {loading?<h4 className={"text-center"}><img src={defaultLoader} className={"mt-3 mb-3"} width={"40px"} /></h4>:""}
            <p style={{textAlign:"right",marginTop:"10px"}}>Showing <b>{filteredData.length}</b> out of <b>{totalTracking}</b></p>
            {/*</DataTableExtensions>*/}
          </CardBody>
        </Card>
        <OrderViewModal
          orderId={rowId}
          viewModal={viewModal}
          setViewModal={data => {
            setViewModal(data)
          }}
        />
      </div>
    </div>
  )
}
TrackingLogs.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default TrackingLogs
